import {
  getNameDescriptionTableColumn,
  getBrandTableColumn,
  getTimeTableColumn,
  // getStatusTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'
export default {
  computed: {
    columns () {
      return [
        getNameDescriptionTableColumn({
          field: 'product_type',
          title: i18n.t('bill.product_type'),
          hideField: true,
          descShow: false,
          showDesc: false,
          edit: false,
          slotCallback: row => {
            return (
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{this.getResName(row.product_type)}</side-page-trigger>
            )
          },
        }),
        {
          field: 'product_types',
          title: i18n.t('bill.product_type'),
          sortable: true,
          formatter: ({ row }) => {
            return this.getResName(row.product_type)
          },
        },
        {
          field: 'origin_res_type',
          title: i18n.t('bill.origin_res_type'),
          sortable: true,
          formatter: ({ row }) => {
            return row.origin_res_type || '-'
          },
        },
        getBrandTableColumn({ field: 'provider' }),
        {
          field: 'origin_usage_type',
          title: i18n.t('bill.origin_usage_type'),
          sortable: true,
        },
        getTimeTableColumn(),
        getTimeTableColumn({ field: 'updated_at', title: i18n.t('table.title.update_time') }),
        // getStatusTableColumn({
        //   field: 'status',
        //   title: i18n.t('common.status'),
        //   statusModule: 'billProduct',
        // }),
      ]
    },
  },
  methods: {
    getResName (name) {
      // if (this.$te(`bill_resource_type.${name}`)) {
      //   return this.$t(`bill_resource_type.${name}`)
      // }
      return name || '-'
    },
  },
}
